import ActionTypes from '../constants/ActionTypes';

const fetchCardPointData = (cardId) => ({
  type: ActionTypes.CARD_POINT_DATA_FETCH,
  payload: {
    cardId,
  },
});

fetchCardPointData.success = (cardId, pointSystemId, item) => ({
  type: ActionTypes.CARD_POINT_DATA_FETCH__SUCCESS,
  payload: {
    cardId,
    pointSystemId,
    item,
  },
});

fetchCardPointData.failure = (cardId, error) => ({
  type: ActionTypes.CARD_POINT_DATA_FETCH__FAILURE,
  payload: {
    cardId,
    error,
  },
});

const upsertCardPointData = (cardId, data) => ({
  type: ActionTypes.CARD_POINT_DATA_UPSERT,
  payload: {
    cardId,
    data,
  },
});

upsertCardPointData.success = (item) => ({
  type: ActionTypes.CARD_POINT_DATA_UPSERT__SUCCESS,
  payload: {
    item,
  },
});

upsertCardPointData.failure = (cardId, error) => ({
  type: ActionTypes.CARD_POINT_DATA_UPSERT__FAILURE,
  payload: {
    cardId,
    error,
  },
});

const completeCardPointData = (cardId) => ({
  type: ActionTypes.CARD_POINT_DATA_COMPLETE,
  payload: {
    cardId,
  },
});

completeCardPointData.success = (item, archivedItem) => ({
  type: ActionTypes.CARD_POINT_DATA_COMPLETE__SUCCESS,
  payload: {
    item,
    archivedItem,
  },
});

completeCardPointData.failure = (cardId, error) => ({
  type: ActionTypes.CARD_POINT_DATA_COMPLETE__FAILURE,
  payload: {
    cardId,
    error,
  },
});

const uncompleteCardPointData = (cardId) => ({
  type: ActionTypes.CARD_POINT_DATA_UNCOMPLETE,
  payload: {
    cardId,
  },
});

uncompleteCardPointData.success = (item) => ({
  type: ActionTypes.CARD_POINT_DATA_UNCOMPLETE__SUCCESS,
  payload: {
    item,
  },
});

uncompleteCardPointData.failure = (cardId, error) => ({
  type: ActionTypes.CARD_POINT_DATA_UNCOMPLETE__FAILURE,
  payload: {
    cardId,
    error,
  },
});

export default {
  fetchCardPointData,
  upsertCardPointData,
  completeCardPointData,
  uncompleteCardPointData,
};

